import { formatDateOnly } from '@/lib/format';

/**
 * A bare `DateOnly` string ("2026-03-31"), formatted on the UTC clock (M1-27).
 *
 * ⚠️ <b>The `timeZone: 'UTC'` is not optional.</b> An effective date has no
 * time in it, so when `new Date(...)` parses one it anchors the value at UTC
 * midnight — and formatting that in the viewer's own zone prints the PREVIOUS
 * calendar day for anyone west of UTC. An assignment starting on the 1st would
 * read as starting on the 31st for every US shop this product is built for,
 * which is precisely the audience.
 *
 * The same rule and the same one-line helper M1-37 wrote for licence expiry
 * dates and M1-24 for `hireDate`. It is a separate module rather than a local
 * function so both fleet screens and the profile section share ONE of it — the
 * bug is invisible in jsdom (which runs in UTC, where the two agree) and
 * invisible to a developer in London, so three copies would be three chances
 * for one to drift and nothing to catch it.
 */
export function formatVehicleDate(value: string): string {
  return formatDateOnly(value);
}
